//  Node imports
import {
  ReelPanelController,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-leopard/dist";
import { IEvent, dispatcher, toInt, ingenuity, killDelayedCall, delayedCall, EventConstants } from "@quest/base-core";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";

//  Class imports
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

/**
 * ReelPanelControllerGame class hanles the slot reel functionality for the base game.
 */
export class ReelPanelControllerGame extends ReelPanelController {
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.PLAY_MUSIC_SPIN, this.playMusicSpin, this);
    dispatcher.on(eventDispatchers.HIDE_REEL_BEHIND_WILD_BG, this.hideAnimReel, this);
    dispatcher.on(eventDispatchers.SHOW_ANIM_REEL, this.showAnimReel, this);
    dispatcher.on(eventDispatchers.ENABLE_ANIM_REEL_ON_BET_CHANGE, this.visibleAllAnimReelOnBetChange, this);
  }
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.PLAY_MUSIC_SPIN, this.playMusicSpin, this);
    dispatcher.off(eventDispatchers.HIDE_REEL_BEHIND_WILD_BG, this.hideAnimReel, this);
    dispatcher.off(eventDispatchers.SHOW_ANIM_REEL, this.showAnimReel, this);
    dispatcher.off(eventDispatchers.ENABLE_ANIM_REEL_ON_BET_CHANGE, this.visibleAllAnimReelOnBetChange, this);
  }

  // Overrided to destroy the current cascde spine data on nextspin
  protected onSpinReel(evt: IEvent): void {
    delayedCall("spinDelay", 100, () => {
      killDelayedCall("spinDelay");
      if (this.model.getHasEnoughBalance() || !ingenuity.configData.isBSPOTEnable) {
        this.reelView.fireEvent(SlotEventConstants.SPIN);
        if (
          !(ingenuity.parserModel as GameParserModel).getPromotionalFreeGame() &&
          ingenuity.configData.isBSPOTEnable
        ) {
          dispatcher.fireEvent(SlotEventConstants.UPDATE_BALANCE_METER_AFTER_SPIN_CLICK);
        }
        dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, true);
      }
      if (ingenuity.configData.endReqSent) {
        ingenuity.configData.endReqSent = false;
        this.sendSpinRequest();
        if (ingenuity.configData.isBSPOTEnable) {
          if (!this.model.getHasEnoughBalance()) {
            (ingenuity.parserModel as GameParserModel).setIsOutOfBalance(false);
          }
        }
      }
    });
    if (this.model.getHasEnoughBalance() || !ingenuity.configData.isBSPOTEnable) {
      this.playReelSpinSound();
      this.fadeBaseGameSound();
    } else {
      dispatcher.fireEvent(EventConstants.INSUFFICIENT_FUNDS);
    }
    killDelayedCall("voiceSoundDelay");
    this.playReelSpinSound();
  }
  /**
   * overrided to remove unsubscribe of SHOW_ANTICIPATION
   * and break call between feature presentation and check for win after reel stop
   */
  protected onSpinComplete(evt?: IEvent): void {
    (ingenuity.parserModel as GameParserModel).setIsSpinClicked(false);
    ingenuity.configData.spinComplete = true;
    this.reelView.getModel().quickSpin = false;
    this.reelView.setStopNow(false);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_IS_REEL_SPINNING, false);
    dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
    dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    ingenuity.configData.currentAnticipation = -1;
  }

  /**
   * onReelStopped method overrided to play anticipation sound.
   * @param evt
   */
  protected onReelStopped(evt: IEvent): void {
    super.onReelStopped(evt);
    if (toInt(evt.toString()) === 4 && ingenuity.configData.isPlayAnticipationSound) {
      // Play anticipation reel stop sound
      ingenuity.configData.isPlayAnticipationSound = false;
      (ingenuity.soundManager as any).playSound(
        SoundConstantGame.ANTICIPATION_REEL_STOP,
        1,
        false,
        gameConstants.SOUND_LIST_PRELOAD
      );
      (ingenuity.soundManager as any).stop(SoundConstantGame.ANTICIPATION_SOUND, gameConstants.SOUND_LIST_PRELOAD);
    }
  }

  /**
   *  playAnticipationSound method plays the anticipation sound.
   */
  protected playAnticipationSound(): void {
    if (!ingenuity.configData.isPlayAnticipationSound) {
      ingenuity.configData.isPlayAnticipationSound = true;
      if (
        (ingenuity.soundManager as any).getSoundInstance(
          SoundConstant.BASEGAME_BGMLOOP,
          gameConstants.SOUND_LIST_PRELOAD
        )
      ) {
        (ingenuity.soundManager as any).getSoundInstance(
          SoundConstant.BASEGAME_BGMLOOP,
          gameConstants.SOUND_LIST_PRELOAD
        ).volume = 0.7;
      }
      if (
        !(
          (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.ANTICIPATION_SOUND) &&
          (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.ANTICIPATION_SOUND).soundPlaying
        )
      ) {
        (ingenuity.soundManager as any).play(
          SoundConstantGame.ANTICIPATION_SOUND,
          1,
          true,
          gameConstants.SOUND_LIST_PRELOAD
        );
      }
    }
  }

  // Override
  protected checkForAnticipation(symbolObj: any, listLength: number): void {
    let i: number, j: number, k: number, n: number;
    let symbolCount: number = 0;
    let anticipation: number[] = [];
    for (i = 0; i < this.reelView.getModel().numReels; i++) {
      this.reelView.getModel().anticipationSpin[i] = 0;
      if (symbolObj.aniticipationRunOnReel[i] > 0) {
        if (
          symbolCount >= symbolObj.symbolCount &&
          symbolObj.aniticipationRunOnReel[i] !== -1 &&
          !ingenuity.configData.checkForActualWild[i]
        ) {
          if (ingenuity.configData.anticipationRunAfterFeature) {
            anticipation[i] = 1;
          } else {
            if (symbolCount >= symbolObj.symbolCount + 1) {
              anticipation[i] = 0;
            } else {
              anticipation[i] = 1;
            }
          }
        }
      }
      for (j = 0; j < this.model.getReelGrid()[i].length; j++) {
        if (
          this.model.getReelGrid()[i][j] === symbolObj.symbolId &&
          symbolObj.aniticipationRunOnReel[i] !== -1 &&
          !ingenuity.configData.checkForActualWild[i]
        ) {
          symbolCount++;
        }
      }
    }
    this.anticipationList.push(anticipation);
    if (this.anticipationList.length === listLength) {
      for (k = 0; k < this.anticipationList.length; k++) {
        for (n = 0; n < this.anticipationList[k].length; n++) {
          if (this.anticipationList[k][n] === 1) {
            this.reelView.getModel().anticipationSpin[n] = 1;
          }
        }
      }
    }
    this.checkForlandingAnim(symbolObj, listLength);
  }
  /**
   * to hide animation reel behind wild
   */
  private hideAnimReel(evt: IEvent): void {
    this.reelView.getAnimReels()[evt.data].visible = false;
  }
  private visibleAllAnimReelOnBetChange(): void {
    for (let index = 0; index < 5; index++) {
      this.reelView.getAnimReels()[index].visible = true;
    }
  }
  /**
   * to show animation reel behind wild
   */
  private showAnimReel(): void {
    const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
    purpleWild.forEach((element: number) => {
      this.reelView.getAnimReels()[element].visible = true;
    });
  }
  /**
   * Method fadeBaseGameSound to fade and stop base game BGM and intro sound.
   */
  private fadeBaseGameSound(): void {
    const audioController: any = ingenuity.soundManager as any;
    if (audioController.getSoundInstance(SoundConstantGame.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)) {
      audioController.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD).volume = 0;
    } else {
      audioController.playSound(SoundConstant.BASEGAME_BGMLOOP, 0, true, gameConstants.SOUND_LIST_PRELOAD);
      audioController.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD).volume = 0;
    }
    if (audioController.getSoundInstance(SoundConstantGame.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD)) {
      audioController.stop(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    }
  }
  /**
   * Method playReelSpinSound to play reel spin sound
   */
  private playReelSpinSound(): void {
    const audioController: any = ingenuity.soundManager as any;
    if (
      !audioController.getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD) &&
      !ingenuity.configData.isReelSpinMusicPlaying
    ) {
      this.playMusicSpin();
      this.fadeBaseGameSound();
    }
  }

  /**
   * Method to play reel spin sound if no win
   */
  private playMusicSpin(): void {
    ingenuity.configData.isReelSpinMusicPlaying = true;
    const audioController: any = ingenuity.soundManager as any;
    audioController.stop(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD);
    audioController.playSound(SoundConstantGame.MUSIC_SPIN, gameConstants.MUSIC_SPIN_VOLUME, false);

    audioController.getSoundInstance(SoundConstantGame.MUSIC_SPIN).onMarkerComplete.addOnce(() => {
      if (ingenuity.currentGame.state.getCurrentState().key !== SlotConstants.freeGameState) {
        if ((ingenuity.parserModel as GameParserModel).getHasWin() || this.model.isReelSpinning()) {
          this.playMusicSpin();
        } else {
          ingenuity.configData.isReelSpinMusicPlaying = false;
          if (audioController.getSoundInstance(SoundConstantGame.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)) {
            audioController.getSoundInstance(
              SoundConstant.BASEGAME_BGMLOOP,
              gameConstants.SOUND_LIST_PRELOAD
            ).volume = 1;
          } else {
            audioController.playSound(SoundConstant.BASEGAME_BGMLOOP, 1, true, gameConstants.SOUND_LIST_PRELOAD);
          }
        }
      }
    }, this);
  }

  /**
   * overrided to send landing symbols data on every reel
   */
  protected onReelStoping(evt?: IEvent): void {
    this.view.clearAnticipation();
    if (
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] &&
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] === 1
    ) {
      dispatcher.fireEvent(SlotEventConstants.SHOW_ANTICIPATION, toInt(evt.toString()) + 1);
    }
    const value = (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()[0][toInt(evt.toString())];
    if (
      value === undefined &&
      !this.model.getIsTurboModeOn() &&
      !ingenuity.configData.checkForActualWild[toInt(evt.toString())]
    ) {
      (ingenuity.soundManager as any).playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
    }
    if (this.model.getIsTurboModeOn() && toInt(evt.toString()) === 0) {
      (ingenuity.soundManager as any).playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
    }
    const checkForWildPresent = ingenuity.configData.checkForActualWild[toInt(evt.toString())];
    for (let m = 0; m < (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel().length; m++) {
      const value = (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()[m][toInt(evt.toString())];
      !checkForWildPresent && value && dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_LANDING_SOUNDS, value);
    }
    if (
      this.reelView.getModel().landingOnReel[toInt(evt.toString())] &&
      this.reelView.getModel().landingOnReel[toInt(evt.toString())] === 1 &&
      value &&
      !checkForWildPresent
    ) {
      dispatcher.fireEvent(SlotEventConstants.SHOW_LANDINGANIMATION, [
        this.model.getReelGrid(),
        this.reelView,
        toInt(evt.toString()),
      ]);
    }
    if (
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] &&
      this.reelView.getModel().anticipationSpin[toInt(evt.toString()) + 1] === 1 &&
      !ingenuity.configData.spinStopPressed
    ) {
      this.fadeSymbolOnAnticipation(toInt(evt.toString()));
      ingenuity.configData.currentAnticipation = toInt(evt.toString()) + 1;
    }
    // to unfade all reels on last reel stopping
    if (toInt(evt.toString()) === 4) {
      this.unFadeSymbolAfterAnticipation();
    }
  }

  /**
   *  To show faded symbol except for bonus symbols on reels during anticipation
   * */
  private fadeSymbolOnAnticipation(reel: number): void {
    let numOfReel: number = reel;
    for (let i: number = 0; i <= numOfReel; i++) {
      this.reelView.children[i].forEach((sym: any, index: number) => {
        if (sym.num !== gameConstants.SCATTER_SYM_NUM) {
          sym.tint = gameConstants.FADED_SYMBOL;
        } else {
          if (sym.y < 0 || sym.y > (ingenuity.configData.symPerReel[0] - 1) * this.reelView.json.symHeight) {
            sym.tint = gameConstants.FADED_SYMBOL;
          }
        }
      });
      dispatcher.fireEvent(eventDispatchers.HANDLE_TINT_WILD_SYMBOL, { tint: gameConstants.FADED_SYMBOL });
      dispatcher.fireEvent(eventDispatchers.HANDLE_TINT_WILD_SKULLS, { tint: gameConstants.FADED_SYMBOL });
    }
  }

  /**
   * to unfade symbol  on reels after anticipation ends
   */
  private unFadeSymbolAfterAnticipation(): void {
    let numOfReel: number = this.reelView.getModel().numReels;
    for (let i: number = 0; i < numOfReel; i++) {
      this.reelView.children[i].forEach((sym: any) => {
        sym.tint = gameConstants.UNFADED_SYMBOL;
      });
    }
    dispatcher.fireEvent(eventDispatchers.HANDLE_TINT_WILD_SYMBOL, { tint: gameConstants.UNFADED_SYMBOL });
    dispatcher.fireEvent(eventDispatchers.HANDLE_TINT_WILD_SKULLS, { tint: gameConstants.UNFADED_SYMBOL });
  }
}
